var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTasmania(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "47px",
    height: "52px",
    viewBox: "0 0 47 52",
    enableBackground: "new 0 0 47 52",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "46.565,52 45.017,49.87 32.805,42.44 32.771,42.394 26.581,33.333 33.199,31.867 33.493,31.771  31.77,31.366 27.685,31.131 23.818,31.131 21.128,31.738 20.354,32.623 22.437,33.255 19.18,42.488 19.062,42.532 2.544,48.683  0.324,50.357 0,49.928 2.283,48.205 2.32,48.192 18.756,42.072 21.742,33.605 19.4,32.895 20.839,31.252 23.788,30.594  27.7,30.594 31.87,30.838 35.497,31.691 33.328,32.389 27.475,33.686 33.184,42.041 45.388,49.467 47,51.684  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "5.068,51.684 4.896,51.368 19.014,43.621 21.917,33.382 22.262,33.479 19.318,43.863  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "40.97,51.971 32.774,44.093 32.762,44.073 26.73,34.231 26.73,33.43 27.089,33.43 27.089,34.131  33.056,43.865 41.218,51.713  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 16.737,
    y: 46.199,
    transform: "matrix(0.1152 0.9933 -0.9933 0.1152 63.3962 21.7629)",
    fill: "#FFFFFF",
    width: 5.489,
    height: 0.538
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 31.895,
    y: 43.873,
    transform: "matrix(0.9612 0.2757 -0.2757 0.9612 14.0893 -7.0619)",
    fill: "#FFFFFF",
    width: 0.538,
    height: 5.427
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 26.641,
    y: 33.833,
    transform: "matrix(0.9988 0.049 -0.049 0.9988 1.7572 -1.2716)",
    fill: "#FFFFFF",
    width: 0.359,
    height: 2.759
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 21.91,
    y: 33.43,
    fill: "#FFFFFF",
    width: 0.359,
    height: 2.846
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 18.64,
    y: 33.893,
    transform: "matrix(0.0601 0.9982 -0.9982 0.0601 52.7668 12.1043)",
    fill: "#FFFFFF",
    width: 2.632,
    height: 0.359
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 19.907,
    y: 32.486,
    transform: "matrix(0.084 0.9965 -0.9965 0.084 51.8613 8.9144)",
    fill: "#FFFFFF",
    width: 2.349,
    height: 0.359
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 22.774,
    y: 31.663,
    transform: "matrix(0.1134 0.9935 -0.9935 0.1134 52.6668 4.6628)",
    fill: "#FFFFFF",
    width: 1.894,
    height: 0.358
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 27.521,
    y: 30.862,
    fill: "#FFFFFF",
    width: 0.358,
    height: 1.921
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 31.528,
    y: 31.092,
    transform: "matrix(0.9896 0.1441 -0.1441 0.9896 4.9124 -4.2368)",
    fill: "#FFFFFF",
    width: 0.359,
    height: 1.411
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 34.109,
    y: 31.65,
    transform: "matrix(0.9728 0.2316 -0.2316 0.9728 8.5477 -7.0477)",
    fill: "#FFFFFF",
    width: 0.358,
    height: 2.456
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 32.726,
    y: 32.143,
    transform: "matrix(0.9921 0.1254 -0.1254 0.9921 4.5149 -3.8577)",
    fill: "#FFFFFF",
    width: 0.358,
    height: 3.593
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 30.01,
    y: 32.942,
    transform: "matrix(0.9917 0.1284 -0.1284 0.9917 4.7151 -3.5885)",
    fill: "#FFFFFF",
    width: 0.357,
    height: 3.665
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "33.156,51.952 32.974,51.72 32.789,51.204 32.34,51.204 31.999,50.753 31.788,50.252  31.531,49.743 31.439,49.28 31.063,48.885 31.063,48.469 30.866,47.779 30.55,47.247 30.022,45.957 29.78,45.207 29.514,44.455  29.358,43.794 29.236,43.464 29.032,43.107 28.71,42.438 28.499,41.858 28.227,41.407 28.043,40.835 27.908,40.324 27.793,40.005  27.407,39.591 27.352,38.84 27.181,38.334 26.961,37.827 26.848,37.438 26.572,37.072 26.572,36.465 27.889,35.988 28.011,36.324  26.932,36.717 26.932,36.952 27.175,37.273 27.302,37.716 27.516,38.206 27.708,38.791 27.756,39.438 28.106,39.814 28.25,40.219  28.387,40.734 28.562,41.276 28.829,41.719 29.04,42.298 29.35,42.94 29.566,43.325 29.705,43.701 29.86,44.363 30.12,45.092  30.359,45.834 30.876,47.1 31.205,47.658 31.422,48.444 31.422,48.741 31.771,49.108 31.878,49.648 32.112,50.101 32.32,50.592  32.516,50.846 33.041,50.846 33.291,51.544 33.438,51.731  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "18.609,51.905 18.274,51.777 18.674,50.721 18.986,50.629 18.986,50.144 19.158,49.774  19.158,49.104 19.451,48.886 19.699,48.223 19.777,46.802 19.863,45.838 20.137,44.927 20.267,44.198 20.38,43.326 20.591,42.746  20.807,42.086 20.903,41.165 20.91,40.335 21.107,39.648 21.115,38.962 21.352,38.197 21.528,37.693 21.528,37.201 21.91,36.543  21.91,36.268 19.737,35.203 21.054,33.614 23.828,32.778 31.443,32.778 34.42,33.776 32.88,34.729 30.242,35.557 28.773,36.075  28.654,35.736 30.129,35.217 32.751,34.393 33.583,33.875 31.385,33.137 23.855,33.137 21.262,33.926 20.304,35.082 22.27,36.045  22.27,36.64 21.887,37.299 21.887,37.755 21.692,38.311 21.466,39.042 21.458,39.723 21.261,40.409 21.26,41.193 21.154,42.179  20.93,42.863 20.724,43.43 20.621,44.253 20.483,45.02 20.212,45.924 20.135,46.827 20.045,48.323 19.75,49.109 19.517,49.284  19.517,49.854 19.345,50.222 19.345,50.896 18.946,51.014  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 27.629,
    y: 36.633,
    transform: "matrix(0.3509 0.9364 -0.9364 0.3509 53.1482 -1.8346)",
    fill: "#FFFFFF",
    width: 0.537,
    height: 1.576
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "29.399,37.119 29.24,36.606 30.108,36.334 32.656,35.477 33.533,34.945 33.772,33.881  34.298,33.998 34.008,35.287 32.855,35.977 30.274,36.846  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "32.449,41.104 32.091,41.087 32.254,37.756 32.499,36.84 32.499,35.748 32.857,35.748  32.851,36.909 32.606,37.83  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "33.739,41.542 33.381,41.521 33.67,36.612 33.592,35.34 33.95,35.316 34.029,36.612  34.028,36.623  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 30.616,
    y: 36.353,
    transform: "matrix(0.998 0.0627 -0.0627 0.998 2.42 -1.8573)",
    fill: "#FFFFFF",
    width: 0.358,
    height: 2.532
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 21.05,
    y: 37.052,
    transform: "matrix(0.8681 0.4964 -0.4964 0.8681 21.4211 -5.6215)",
    fill: "#FFFFFF",
    width: 0.478,
    height: 0.896
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "20.613,37.311 19.777,36.797 19.777,35.164 20.135,35.164 20.135,36.596 20.8,37.004  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "14.406,51.969 14.154,51.714 19.004,46.903 21.122,38.424 21.54,37.318 21.875,37.445  21.461,38.541 19.327,47.088  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "34.852,51.928 32.112,46.951 28.314,38.906 27.636,37.707 26.589,35.482 26.914,35.33  27.955,37.541 28.633,38.742 32.432,46.787 35.166,51.755  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 18.928,
    y: 50.781,
    transform: "matrix(0.9999 0.0137 -0.0137 0.9999 0.7004 -0.3468)",
    fill: "#FFFFFF",
    width: 13.475,
    height: 0.358
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 19.244,
    y: 49.833,
    transform: "matrix(0.9999 0.0104 -0.0104 0.9999 0.5218 -0.2635)",
    fill: "#FFFFFF",
    width: 12.67,
    height: 0.358
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 19.797,
    y: 48.929,
    transform: "matrix(0.9999 0.0145 -0.0145 0.9999 0.7138 -0.3665)",
    fill: "#FFFFFF",
    width: 11.735,
    height: 0.359
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 20.034,
    y: 48.041,
    transform: "matrix(0.9999 0.0166 -0.0166 0.9999 0.8022 -0.417)",
    fill: "#FFFFFF",
    width: 11.084,
    height: 0.358
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 20.015,
    y: 47.435,
    transform: "matrix(0.9999 0.0121 -0.0121 0.9999 0.5758 -0.3037)",
    fill: "#FFFFFF",
    width: 10.938,
    height: 0.359
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 20.016,
    y: 46.579,
    fill: "#FFFFFF",
    width: 10.489,
    height: 0.358
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 20.173,
    y: 45.842,
    transform: "matrix(0.9999 0.0159 -0.0159 0.9999 0.7359 -0.3944)",
    fill: "#FFFFFF",
    width: 9.937,
    height: 0.358
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 20.391,
    y: 45.077,
    fill: "#FFFFFF",
    width: 9.535,
    height: 0.359
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 20.548,
    y: 44.301,
    transform: "matrix(1 0.0087 -0.0087 1 0.3881 -0.2167)",
    fill: "#FFFFFF",
    width: 9.087,
    height: 0.358
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 20.679,
    y: 43.701,
    transform: "matrix(0.9998 0.0224 -0.0224 0.9998 0.987 -0.5499)",
    fill: "#FFFFFF",
    width: 8.826,
    height: 0.358
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 20.756,
    y: 42.799,
    transform: "matrix(0.9992 0.0406 -0.0406 0.9992 1.767 -0.9793)",
    fill: "#FFFFFF",
    width: 8.436,
    height: 0.359
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 21.081,
    y: 41.996,
    transform: "matrix(0.9998 0.0208 -0.0208 0.9998 0.8825 -0.5084)",
    fill: "#FFFFFF",
    width: 7.607,
    height: 0.358
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 21.181,
    y: 41.285,
    fill: "#FFFFFF",
    width: 7.165,
    height: 0.358
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 21.289,
    y: 40.564,
    transform: "matrix(0.9999 0.0126 -0.0126 0.9999 0.5163 -0.3089)",
    fill: "#FFFFFF",
    width: 6.885,
    height: 0.359
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 21.29,
    y: 39.704,
    fill: "#FFFFFF",
    width: 6.411,
    height: 0.358
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 21.286,
    y: 38.836,
    fill: "#FFFFFF",
    width: 6.111,
    height: 0.357
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 21.707,
    y: 38.06,
    fill: "#FFFFFF",
    width: 5.611,
    height: 0.358
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 24.233,
    y: 34.884,
    transform: "matrix(0.0505 0.9987 -0.9987 0.0505 60.618 11.2132)",
    fill: "#FFFFFF",
    width: 0.358,
    height: 5.205
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 24.063,
    y: 34.624,
    transform: "matrix(0.0491 0.9988 -0.9988 0.0491 59.9851 10.9504)",
    fill: "#FFFFFF",
    width: 0.358,
    height: 4.71
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 24.196,
    y: 34.264,
    transform: "matrix(0.0491 0.9988 -0.9988 0.0491 59.6185 10.3481)",
    fill: "#FFFFFF",
    width: 0.358,
    height: 4.443
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M0.412,35.211l-0.13-0.123c0.061-0.065,1.517-1.588,3.455-1.537c0.227-0.045,3.09-0.572,3.414,0.994 l-0.175,0.036c-0.295-1.423-3.184-0.858-3.213-0.853l-0.01,0.002h-0.01C1.889,33.682,0.426,35.195,0.412,35.211z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M15.33,42.475l-0.099-0.149c0.026-0.018,0.038-0.037,0.039-0.069c0.015-0.335-0.957-1.234-1.573-1.723 l-0.018-0.019c-0.584-0.823-0.998-3.049-1.016-3.144c-0.313-1.529-0.911-2.591-1.774-3.154c-0.597-0.389-1.185-0.441-1.512-0.429 l0.005,0.003c0.235,0.082,0.432,0.189,0.564,0.328l0.423,0.445l-1.076-0.617c-1.083-0.364-3.094-0.192-3.118-0.19L6.16,33.578 c0.089-0.008,1.637-0.14,2.772,0.092l0.14-0.031c0.038-0.008,0.952-0.199,1.912,0.426c0.907,0.59,1.532,1.691,1.856,3.272 c0.004,0.024,0.421,2.264,0.979,3.064c0.212,0.168,1.654,1.337,1.631,1.861C15.445,42.353,15.404,42.426,15.33,42.475z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M14.817,43.631l-0.179-0.014c0.003-0.042,0.087-1.035,0.761-1.352c0.459-0.214,1.065-0.057,1.804,0.469 l-0.104,0.146c-0.682-0.485-1.229-0.638-1.624-0.453C14.895,42.699,14.818,43.621,14.817,43.631z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M10.543,45.137l-0.178-0.023l0.116-0.895c-0.008-0.049,0.005-0.098,0.038-0.141 c0.233-0.312,1.781-0.375,2.153-0.385c0.402-0.229,2.354-0.13,2.58-0.117l-0.01,0.179c-0.851-0.046-2.279-0.061-2.49,0.099 l-0.023,0.018l-0.028,0.001c-1.057,0.027-2.012,0.177-2.043,0.32l0.004,0.017l-0.001,0.019L10.543,45.137z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M9.004,45.859c-0.208-0.795-1.269-1.805-1.279-1.815c-0.433-0.273-1.946-2.699-2.01-2.803 c-0.4-0.493-0.918-0.774-1.534-0.826C2.393,40.264,0.34,42.054,0.32,42.07l-0.119-0.134c0.086-0.076,2.132-1.857,3.996-1.7 c0.667,0.057,1.227,0.359,1.665,0.901c0.438,0.701,1.632,2.548,1.974,2.766c0.058,0.054,1.121,1.065,1.342,1.91L9.004,45.859z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M6.998,38.338c-1.081-1.164-2.124-1.703-3.101-1.603c-1.257,0.132-1.972,1.302-1.979,1.313l-0.154-0.092 c0.031-0.052,0.769-1.259,2.114-1.4c1.037-0.107,2.13,0.45,3.25,1.659L6.998,38.338z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M0.211,37.496l-0.099-0.15c0.079-0.052,1.938-1.266,2.848-0.434l-0.121,0.133 C2.03,36.307,0.229,37.483,0.211,37.496z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M9.494,40.306L9.32,40.264c0.019-0.079,0.197-0.779,0.621-0.844c0.271-0.041,0.549,0.181,0.847,0.681 l-0.154,0.092c-0.25-0.418-0.48-0.623-0.666-0.596C9.708,39.637,9.538,40.122,9.494,40.306z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M7.438,41.91l-0.172-0.05c0.018-0.063,0.462-1.549,1.42-1.76c0.52-0.112,1.075,0.168,1.657,0.837 l-0.135,0.117c-0.536-0.614-1.035-0.878-1.482-0.778C7.871,40.464,7.443,41.896,7.438,41.91z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M11.175,43.796l-0.177-0.028c0.004-0.027,0.47-2.771,2.732-3.392l0.047,0.174 C11.625,41.141,11.179,43.77,11.175,43.796z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M37.418,44.86l-0.351-0.069c0.12-0.604-2.035-2.286-3.604-3.288l-0.055-0.035l-0.02-0.063 c-0.275-0.877-0.916-0.91-0.923-0.91l0.013-0.358c0.036,0.001,0.869,0.045,1.231,1.099C34.483,41.732,37.624,43.824,37.418,44.86z "
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTasmania);
export default __webpack_public_path__ + "static/media/tasmania.cd1b8979a7248eb27b56cff9033a712a.svg";
export { ForwardRef as ReactComponent };